var map = {
	"./BTN_XPLOSION_A.png": 5606,
	"./BTN_XPLOSION_B.png": 7001,
	"./COMPRAR.png": 1621,
	"./COMPRAR_HOVER.png": 8607,
	"./COPA_MEGA.png": 1737,
	"./COPA_QUESO.png": 8476,
	"./COPA_SAL.png": 9547,
	"./COPA_SWITCH.png": 5037,
	"./Choca_a_Checo.mp4": 4905,
	"./ENLACE.png": 5357,
	"./ENLACE_HOVER.png": 8668,
	"./PLAY.png": 3516,
	"./PLAY_HOVER.png": 6619,
	"./Ruffles_mega.png": 8164,
	"./Ruffles_queso.png": 6740,
	"./Ruffles_sal.png": 22,
	"./Ruffles_switch.png": 9470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;